import { AddressType } from '../../constants/address-type.js';
import { ADDRESS_CONSTRAINTS } from '../address/constraints.js';
// Vendors allow Shipping + Remit-To only — at most one of each type.
export const VendorAddressType = {
    SHIPPING: AddressType.SHIPPING,
    REMIT_TO: AddressType.REMIT_TO,
};
const vendorAddressTypeIds = Object.values(VendorAddressType);
export function isVendorAddressTypeId(typeId) {
    return vendorAddressTypeIds.includes(typeId);
}
const VENDOR_ADDRESS_TYPE_META = {
    [AddressType.SHIPPING]: {
        label: 'Shipping',
        takenMessage: 'A shipping address already exists for this vendor.',
    },
    [AddressType.REMIT_TO]: {
        label: 'Remit To',
        takenMessage: 'A remit-to address already exists for this vendor.',
    },
};
export function vendorAddressTypeLabel(typeId) {
    const meta = VENDOR_ADDRESS_TYPE_META[typeId];
    if (!meta) {
        throw new Error(`Unhandled address type: ${String(typeId)}`);
    }
    return meta.label;
}
export function vendorAddressTypeTakenMessage(typeId) {
    return isVendorAddressTypeId(typeId)
        ? VENDOR_ADDRESS_TYPE_META[typeId].takenMessage
        : 'An address of this type already exists for this vendor.';
}
/** Type ids already present (for create/edit type controls and pair-create UX). */
export function unavailableVendorAddressTypeIds(addresses, excludeAddressId) {
    const active = excludeAddressId === undefined
        ? addresses
        : addresses.filter((address) => address.id !== excludeAddressId);
    return [
        ...new Set(active
            .map((address) => address.addressType?.id)
            .filter((typeId) => Boolean(typeId))),
    ];
}
export function canAddVendorAddress(addresses) {
    const unavailable = new Set(unavailableVendorAddressTypeIds(addresses));
    return vendorAddressTypeIds.some((typeId) => !unavailable.has(String(typeId)));
}
/** Default nickname when the user has not entered one yet. */
export function suggestVendorAddressName(vendorName, typeId) {
    const typeLabel = vendorAddressTypeLabel(typeId);
    return `${vendorName} - ${typeLabel}`.slice(0, ADDRESS_CONSTRAINTS.addressName.maxLength);
}
//# sourceMappingURL=rules.js.map